var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-subtitle",class:{
    'ui-subtitle--large': _vm.large,
    'ui-subtitle--default': !_vm.large && !_vm.small,
    'ui-subtitle--small': _vm.small,
    'ui-subtitle--centered': _vm.centered,
  }},[_vm._t("default",function(){return [_c('span',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.purifyAndAllowHtmlTags(_vm.subtitle)),expression:"purifyAndAllowHtmlTags(subtitle)"}]})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }